var label = {
  "touchAction": "manipulation",
  "display": "inline-block",
  "marginBottom": "0.3125rem",
  "color": "#53565a"
};

export { label };
